module.exports = __webpack_public_path__ + "img/Winning.e1656004.png";